module.exports = __webpack_public_path__ + "static/img/glwlgz.7cb8ed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linshi/glwlgz.png
// module id = pZ6f
// module chunks = 44